import React from 'react';
import { useStyletron } from 'baseui';
import { Spinner } from 'baseui/spinner';
import { LoadingContainer } from '../styled-components';
const DEFAULT_VALIDATION_TEXT = 'Running validations';
export type ValidationIndicatorProps = {
  message?: string;
};
export const ValidationIndicator = ({
  message = DEFAULT_VALIDATION_TEXT
}: ValidationIndicatorProps) => {
  const [css, theme] = useStyletron();
  return <LoadingContainer data-testid="validation-indicator">
      <Spinner $size={theme.sizing.scale500} $color={theme.colors.contentSecondary} />
      <div className={css({
      ...theme.typography.LabelXSmall
    })}>{message}</div>
    </LoadingContainer>;
};